import { Star } from "lucide-react";

const TESTIMONIALS = [
  { name: "Sneha K.", role: "Booked Hospital Assist", photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&auto=format&q=70", stars: 5, quote: "My father needed a companion at Ruby Hall for reports. Ravi arrived in 20 minutes, calm and kind. Worth every rupee." },
  { name: "Aditya M.", role: "Booked Airport Assist", photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&auto=format&q=70", stars: 5, quote: "Landed at 2am with my parents. A HeylpMate met us at the terminal, handled luggage and dropped us at the hotel. Life-saver." },
  { name: "Priya R.", role: "Priority Member", photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&auto=format&q=70", stars: 5, quote: "WhatsApp me → Mate arrives → done. I've used it 6 times last month. Absolutely worth ₹99." },
];

export default function TestimonialsWall() {
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 pt-24 md:pt-32">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 mb-10">
        <div>
          <span className="label-eyebrow">customers · pune</span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-tight max-w-2xl">
            Real people. <span className="italic" style={{ color: "var(--secondary)" }}>Real reviews.</span>
          </h2>
        </div>
        <p className="max-w-md text-[color:var(--text-muted)]">
          Every Mate is rated after every task. Here's what customers are saying this month.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {TESTIMONIALS.map((t) => (
          <div key={t.name} className="rounded-3xl border border-black/10 bg-white p-6 card-lift">
            <div className="flex items-center gap-3">
              <img src={t.photo} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
              <div>
                <div className="font-bold text-sm">{t.name}</div>
                <div className="text-xs text-neutral-500">{t.role}</div>
              </div>
            </div>
            <div className="flex gap-0.5 mt-3">
              {Array.from({ length: t.stars }).map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" />)}
            </div>
            <p className="mt-3 text-sm text-neutral-700 leading-relaxed italic">"{t.quote}"</p>
          </div>
        ))}
      </div>
    </section>
  );
}
